export const Hackathon = {
    name: "HACKATHON",
    refName: "hackathon",
    about: `Are you a tech-savvy individual who can collaborate intensively to
            innovate and develop influential solutions to a problem using technology?
            Then why do you wait? Fasten your belts and bump into the signature event of Abacus,
            where you need to team up and brainstorm your ideas to create a prototype.`,
    fee: `Registration Fee - Rs.100`,        
    dateTime: [
        "25/03/2021 and 26/03/2021"
    ],

    contact: [
        {
            name: "Kanika K",
            mobile: "8300295535"
        },
    ],

    // sponsor: "",

    rules: [
        "The event is for a team of three participants (At Least 2 participants)",
        "Problem statement will be provided on 25th March, 2021 and participants are expected to present their prototype on 26th March, 2021",
        "Decisions made by the administrators will be final",
        "Participants must ensure that they have laptop with good internet connectivity for their convenience",
        "Participants must ensure that they have microsoft account"
    ],

    /* rounds: {
        number: 3,
        roundDetails: [
            {
                title: "Prelims",
                description: "Participants will be given 25 mins to answer MCQs which is a combination of technical (OS,DBMS,OOPS..) and general aptitude questions."
            },
            {
                title: "Semi-Finals",
                description: "A debugging round where candidates have to find the logical and syntactical errors in the given code snippets and run the correct code  in the platform provided for various test cases. (30 minutes)"
            },
            {
                title: "Finals",
                description: "A reverse coding round where candidates have to analyze the given input-output sequences and decode the logic behind it. Write a code snippet that will generate the corresponding input output pattern. (30 mins)"
            },
        ]
    }, */
    registration: true
}